import { styled } from "@/components";

const CustomBox = styled("div")(({ theme }) => ({
  padding: theme.spacing(2),
}));

export { CustomBox };
